<div class="data" *ngIf="enableCalls">
    <p><strong>Call Data:</strong></p>
    <select (change)="setData($event)">
        <option disabled [selected]="true">Select an option to view the results of the call.</option>
        <option *ngFor="let item of dataUrls; index as i;" [value]="i">
            {{ item.name }} -
            {{ item.detail }}
        </option>
    </select>
    <ul class="data-list">
        <li *ngFor="let item of dataUrls">
            <a (click)="setData(item)">
                <finder-tooltip
                    [tooltip]="item.detail"
                    [position]="'top-left'"
                    class="tooltip"
                >{{ item.name }}</finder-tooltip>
            </a>
        </li>
    </ul>
    <div class="tip">
        <finder-icon-tooltip
            [name]="'information'"
            [tooltip]="'Click any link to view the results of the call.'"
            [position]="'left'"
            class="tooltip"
        ></finder-icon-tooltip>
    </div>
</div>
<div class="data" *ngIf="dataUrl && enableCalls">
    <p><strong>Call URL:</strong></p>
    <p class="url">
        <a [href]="dataUrl" [title]="dataUrl" target="_blank">{{ dataUrl }}</a>
    </p>
</div>
<div id="json"></div>
